import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Link from '@mui/material/Link';
import StarRating from "../../components/Feedback-Star";
import person1 from "../../assets/person1.png";
import person2 from "../../assets/person2.png";
import person3 from "../../assets/person3.png";
import person4 from "../../assets/person4.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./styles.css";
import { useNavigate } from "react-router-dom";

export default function Ratings(props) {
  console.log('propsinrating', props)
  const navigate = useNavigate();


  var ratings = [
    {
      jobId: "1",
      name: "John",
      profilePic: person1,
      "commnet": "Working with is a solution which connects plumber and homeowner in shortest time possible."

    },
    {
      jobId: "2",
      name: "Mark",
      profilePic: person2,
      commnet: "Working with is a solution which connects plumber and homeowner in shortest time possible."

    },
    {
      jobId: "3",
      name: "Dan",
      profilePic: person3,
      commnet: "Working with is a solution which connects plumber and homeowner in shortest time possible."

    },
    {
      jobId: "4",
      name: "Alan",
      profilePic: person4,
      commnet: "Working with is a solution which connects plumber and homeowner in shortest time possible."

    }

  ]
  var ratings2 = [
    {
      jobId: "1",
      name: "John",
      profilePic: person1,
      "commnet": "Working with is a solution which connects plumber and homeowner in shortest time possible."

    },
    {
      jobId: "2",
      name: "Mark",
      profilePic: person2,
      commnet: "Working with is a solution which connects plumber and homeowner in shortest time possible."

    },
    {
      jobId: "3",
      name: "Dan",
      profilePic: person3,
      commnet: "Working with is a solution which connects plumber and homeowner in shortest time possible."

    },
    // {
    //   jobId: "4",
    //   name: "Alan",
    //   profilePic: person4,
    //   commnet: "Working with is a solution which connects plumber and homeowner in shortest time possible."

    // }

  ]
 var ratinglist=props.name==="service"?ratings:ratings2
  return (
    <div>

      <Grid style={{
        border: '1px solid #E3E3E3', backgroundColor: '#FCFCFC', background: "#FCFCFC 0% 0% no-repeat", boxShadow: "0px 3px 6px #A7A7A729",
        borderRadius: "6px", padding: "20px", marginTop: '2%'
      }}>

        <Typography style={{
          fontSize: "1rem",
          fontWeight: "600",
          letterSpacing: "0.09px",
          color: "#000000",
          fontfamily: 'Rubik',
          paddingBottom: "13px",
        }}>Rating and Reviews</Typography>
        <Grid style={{ display: 'flex' }}>
          <Grid
            style={{ padding: "15px", width: '44%', lineHeight: "1" }}
          >
            <Grid
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                // backgroundColor: "white",
                // borderRadius: "10px",
                // border: '1px solid white'
              }}
            >
              <Typography
                style={{ fontSize: "16px", color: "#0D5C75", fontWeight: "600", paddingTop: '25px', fontfamily: 'Rubik' }}
              >
                Overall Rating
              </Typography>
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Grid
                  style={{ display: "flex", alignItems: "center", padding: "0px" }}
                >
                  <Typography style={{ fontSize: "32px", fontWeight: "500" }}>
                    4.2
                  </Typography>
                  <Grid style={{ padding: "18px", lineHeight: "1" }}>
                    <StarRating size={50} value={4.5} edit={false} />
                    <Typography style={{ fontSize: "10px" }}>
                      From 12 People
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid>
              <Grid
                style={{
                  marginTop: '-28px'
                }}
              >
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: '45px',
                    justifyContent: "space-between",
                    // padding: "6px 6px 10px 6px",
                    borderTop: "2px solid #F2F2F2",
                    marginTop: "35px",
                    backgroundColor: "white",
                    padding: '0px 40px'
                  }}
                >
                  <Typography style={{ fontSize: "14px", fontWeight: "700", color: '#0D5C75', fontfamily: 'Rubik' }}>
                    Wait time
                  </Typography>
                  <StarRating size={60} count={5} value={4} edit={false} />
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: '45px',
                    justifyContent: "space-between",
                    // padding: "6px 6px 10px 6px",
                    borderTop: "2px solid #F2F2F2",
                    backgroundColor: "white",
                    padding: '0px 40px'
                  }}
                >
                  <Typography style={{ fontSize: "14px", fontWeight: "700", color: '#0D5C75', fontfamily: 'Rubik' }}>
                    Professionalism
                  </Typography>
                  <StarRating size={60} count={5} value={3} edit={false} />
                </Grid>

                
                {props.name==="service"?

              (<Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: '45px',
                    justifyContent: "space-between",
                    // padding: "6px 6px 10px 6px",
                    borderTop: "2px solid #F2F2F2",
                    // marginTop: "35px",
                    backgroundColor: "white",
                    padding: '0px 40px'
                  }}
                >
                  <Typography style={{ fontSize: "14px", fontWeight: "700", color: '#0D5C75', fontfamily: 'Rubik' }}>
                    Communication
                  </Typography>
                  <StarRating size={60} count={5} value={4} edit={false} />
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: '45px',
                    justifyContent: "space-between",
                    // padding: "6px 6px 10px 6px",
                    borderTop: "2px solid #F2F2F2",
                    // marginTop: "35px",
                    backgroundColor: "white",
                    padding: '0px 39px'
                  }}
                >
                  <Typography style={{ fontSize: "14px", fontWeight: "700", color: '#0D5C75', fontfamily: 'Rubik' }}>
                    Cleanliness of work
                  </Typography>
                  <StarRating size={60} count={5} value={4} edit={false} />
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: '45px',
                    justifyContent: "space-between",
                    // padding: "6px 6px 10px 6px",
                    borderTop: "2px solid #F2F2F2",
                    // marginTop: "35px",
                    backgroundColor: "white",
                    padding: '0px 40px'
                  }}
                >
                  <Typography style={{ fontSize: "14px", fontWeight: "700", color: '#0D5C75', fontfamily: 'Rubik' }}>
                    Quality of work
                  </Typography>
                  <StarRating size={60} count={5} value={4} edit={false} />
                </Grid>
              </Grid>):(
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                            height:'45px',
                    justifyContent: "space-between",
                    // padding: "6px 6px 10px 6px",
                    borderTop: "2px solid #F2F2F2",
                    backgroundColor: "white",
                    padding:'0px 40px'
                  }}
                >
                  <Typography style={{ fontSize: "14px", fontWeight: "700", color: '#0D5C75',fontfamily: 'Rubik' }}>
                    Comfortness
                  </Typography>
                  <StarRating size={60} count={5} value={1} edit={false} />
                </Grid>
              )
                }
                
              </Grid>
            </Grid>

          </Grid>
          <Grid style={{ borderLeft: "2px dashed #D1E7EB", marginTop: '2%' }}></Grid>
          {/* <hr style={{ borderTop: "dotted 1px", marginTop: '2%' }}></hr> */}
          <Grid style={{ width: '56%', marginTop: '2%' }}>
            <Typography style={{
              fontSize: "12px",
              fontWeight: "600",
              fontfamily: 'Rubik',
              letterSpacing: "0.05px",
              color: "#1F1F1F",
              paddingTop: "20px",
              paddingBottom: "10px",
              marginLeft: '1%'
            }}>Reviewed by 9 people</Typography>

            {
              ratinglist.map(item => {
                return (
                  <div>
                    <Grid style={{ display: "flex", boxShadow: " 0px 3px 6px #91919129", borderRadius: '6px', opacity: '1', alignItems: "center", marginBottom: '7px', padding: '10px', marginLeft: '1%', backgroundColor: '#FFFFFF' }}>


                      <Grid>
                        <img src={item.profilePic} alt="profile" />
                        <Typography style={{ fontSize: '11px', fontfamily: 'Rubik' }}>{item.name}</Typography>
                      </Grid>

                      <Typography style={{
                        fontStyle: 'italic',
                        fontSize: '10px',
                        letterSpacing: "0.06px",
                        lineHeight: 'normal',
                        paddingBottom: '12px',
                        paddingLeft: "23px",
                      }}>{`"${item.commnet}"`}</Typography>

                    </Grid>


                  </div>
                )
              })

            }
            <Grid style={{ display: 'flex', justifyContent: 'center' }}>
              <Link
                style={{ fontStyle: 'italic', fontSize: '13px', fontWeight: '600', color: '#0D5C75', textDecoration: 'none', borderBottom: "1px solid #0D5C75" }} href="#">Load More</Link>

            </Grid>
          </Grid>

        </Grid>

      </Grid>

    </div>
  );
}
